<template>
  <section class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters" style="display: flex; flex-wrap: wrap; align-items: center;">
        <el-form-item>
          <el-input v-model="filters.companyId" placeholder="公司ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.name" placeholder="公司名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list"> 查询 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSynchronous"> 同步 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeRemain"> 统一增加/减少 </el-button>
        </el-form-item>
        <el-form-item style="margin-left: auto; display: flex; align-items: center;">
          公司余量初始值:
          <el-input v-model="initialValue" placeholder="公司创建获取的初始值"  style="width: auto; vertical-align: middle;" />
          <el-button type="primary" @click="confirmDialogVisible3 = true" style="vertical-align: middle; margin-left: 10px;">修改</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :visible.sync="confirmDialogVisible3"
      width="400px"
      title="请确认"
    >
      <span>你确定要执行此操作吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible3 = false">取消</el-button>
        <el-button type="primary" @click="changeInital">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="synchronousVisible" :close-on-click-modal="false" title="编辑"     :style="{ width: '1000px', maxWidth: '100%' ,margin: 'auto' }">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
        <el-form-item label="设置全体公司发送数量" style="display: flex; justify-content: center; align-items: center; height: 200px;">
          <el-input v-model="synchronousValue" placeholder="设置Post余量" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="editLoading" type="primary" @click="confirmDialogVisible1 = true">同步</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="confirmDialogVisible1"
      width="400px"
      title="请确认"
    >
      <span>你确定要执行此操作吗？该操作不可撤销,涉及到所有数据，请谨慎操作！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible1 = false">取消</el-button>
        <el-button type="primary" @click="submitSynchronous">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="changeTableVisible" :close-on-click-modal="false" title="编辑"     :style="{ width: '1000px', maxWidth: '100%' ,margin: 'auto' }">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
        <el-form-item label="设置全体公司增加/减少数量" style="display: flex; justify-content: center; align-items: center; height: 200px;">
          <el-input v-model="synchronousValue" placeholder="设置增加/减少量" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="editLoading" type="primary" @click="confirmDialogVisible2 = true">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="confirmDialogVisible2"
      width="400px"
      title="请确认"
    >
      <span>你确定要执行此操作吗？该操作不可撤销,涉及到所有数据，请谨慎操作！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="submitChange">确认</el-button>
      </span>
    </el-dialog>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
      >
        <el-table-column prop="CompanyID" label="公司ID" width="150" />
        <el-table-column prop="Name" label="公司名称" />
        <el-table-column prop="CreatTime" label="注册时间">
          <template slot-scope="scope">
            {{ scope.row.creatTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="ExpiredTime" label="到期时间">
          <template slot-scope="scope">
            {{ scope.row.expiredTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="RemainNum" label="发送余量" width="150" />
        <el-table-column prop="State" label="状态" width="150" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="handleEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑表单弹窗 -->
      <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑">
        <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
          <el-form-item label="公司ID" prop="CompanyID">
            <el-input v-model="editForm.CompanyID" readonly />
          </el-form-item>
          <el-form-item label="用户名" prop="Name">
            <el-input v-model="editForm.Name" readonly />
          </el-form-item>
          <el-form-item label="发送余量" prop="RemainNum">
            <el-input v-model="editForm.RemainNum" />
          </el-form-item>
          <el-form-item label="状态" prop="State">
            <el-input v-model="editForm.State" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button :loading="editLoading" type="primary" @click="editSubmit">提交</el-button>
        </div>
      </el-dialog>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";
import { formatDate } from "../../../../filters";

export default {
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      synchronousVisible: false,
      synchronousValue: "",
      changeTableVisible:false,
      changeTableValue:"",
      confirmDialogVisible1 : false,
      confirmDialogVisible2 : false,
      confirmDialogVisible3 : false,

      initialValue:"",
      page: {},
      filters: {
        companyId: "",
        name: "",
      },
      editForm: {
        CompanyID: "",
        Name: "",
        RemainNum: "",
        State: "",
      },
      editFormVisible: false,
      editLoading: false,
      expireTime: '0',
    };
  },
  computed: {
    formattedExpireTime() {
      return this.expireTime === '0' ? 'nil' : formatDate(this.expireTime);
    },
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    list() {
      this.listLoading = true;
      const params = {
        ...this.filters,
        page: this.page.page,
        limit: this.page.limit,
      };

      this.axios
        .form("/api/admin/post-company/list", params)
        .then((data) => {
          this.results = data.results;
          this.page = data.page;
          this.initialValue = data.initPostvalue;
          if (this.page.total === 0) {
            this.page.total = this.results.length;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleEdit(row) {
      this.editFormVisible = true;
      this.editForm = { ...row };
    },
    editSubmit() {
      const params = { ...this.editForm };
      this.axios
        .form("/api/admin/post-company/update", params)
        .then(() => {
          this.list();
          this.editFormVisible = false;
          this.$notify.success({ title: "成功", message: "修改成功" });
        })
        .catch((rsp) => {
          this.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    handleSynchronous() {
      this.synchronousVisible = true;
    },
    submitSynchronous() {
      if (isNaN(this.synchronousValue) || this.synchronousValue < 0 || this.synchronousValue === "") {
        this.$notify.error({ title: "错误", message: "未输入或无效数量" });
        return;
      }

      const params = { RemainNum: this.synchronousValue };
      this.axios
        .form("/api/admin/post-company/synchronous", params)
        .then(() => {
          this.list();
          this.synchronousVisible = false;
          this.confirmDialogVisible1 =false;
          this.$notify.success({ title: "成功", message: "修改成功" });
        })
        .catch((rsp) => {
          this.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    changeRemain(){
      this.changeTableVisible=true
    },
    submitChange() {
      if (isNaN(this.synchronousValue) || this.synchronousValue === "") {
        this.$notify.error({ title: "错误", message: "未输入或无效数量" });
        return;
      }
      const params = { Num: this.synchronousValue };
      this.axios
        .form("/api/admin/post-company/change", params)
        .then(() => {
          this.list();
          this.changeTableVisible = false;
          this.confirmDialogVisible2 = false;
          this.$notify.success({ title: "成功", message: "修改成功" });

        })
        .catch((rsp) => {
          this.$notify.error({ title: "错误", message: rsp.message });
        });
    },
    changeInital(){
      if (isNaN(this.initialValue) || this.initialValue === "" || this.initialValue <0 ) {
        this.$notify.error({ title: "错误", message: "未输入或无效数量" });
        return;
      }
      const params = { initialValue: this.initialValue };
      this.axios
        .form("/api/admin/post-company/initial", params)
        .then(() => {
          this.list();
          this.confirmDialogVisible3 = false;
          this.$notify.success({ title: "成功", message: "修改成功" });
        })
        .catch((rsp) => {
          this.$notify.error({ title: "错误", message: rsp.message });
        });
    }
  },
};
</script>
